import { useCheckout as useControlCheckout } from "@/components/results/useCheckout";

// Price & Value variant (#51): checkout is shared with control so cart, pricing
// and tagging stay identical across arms. Only the step that hosts the
// delivery-date picker differs (the supplement step pushes Review to 6).
const REVIEW_STEP = 6;

export function useCheckout() {
    return useControlCheckout(REVIEW_STEP);
}
